import { MutationCache, QueryClient } from '@tanstack/react-query';

import { publishErrorNotice } from './errorNotices';
import { globalMutationErrorNotice } from './mutationErrorPolicy';

/**
 * Lives here rather than in contexts.tsx so the wiring can be exercised by a
 * test without mounting the provider tree — see queryClient.test.ts.
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Stated rather than inherited: mutations here are not idempotent
        // (checkout, seat assignment, enrolment), so a silent second attempt
        // can charge or enrol twice.
        retry: 0,
      },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        const message = globalMutationErrorNotice(error, mutation);
        if (message) publishErrorNotice(message);
      },
    }),
  });
}

export const queryClient = createAppQueryClient();
